<template>
  <nav
    class="w-full md:w-60 bg-white shadow-[0_2px_8px_rgba(0,0,0,0.15)] rounded-2xl p-6 space-y-6"
  >
    <!-- Profile Section -->
    <div class="flex items-center gap-4 border-b pb-6">
      <img
        class="h-14 w-14 rounded-full object-cover"
        :src="$store.state.userDetails.photoLink"
        alt="Avatar"
      />
      <div class="flex flex-col gap-1">
        <span class="text-gray-800 font-medium text-base">{{
          $store.state.userDetails.name
        }}</span>
        <span class="text-xs text-slate-600">
          {{ $store.state.userDetails.role }}</span
        >
      </div>
    </div>

    <!-- Navigation -->
    <ul class="space-y-2">
      <li v-for="(item, index) in itemMenu" :key="index">
        <template v-if="item.name === 'Tracking'">
          <a
            :href="item.path"
            target="_blank"
            rel="noopener"
            class="flex text-sm items-center gap-3 px-4 py-2 rounded-lg hover:bg-primary hover:text-white text-gray-700 transition-all duration-200"
          >
            <component
              :is="item.icon"
              class="w-5 h-5 text-gray-500"
              v-if="item.icon"
            />
            <span>{{ item.name }}</span>
          </a>
        </template>
        <template v-else>
          <router-link
            :to="item.path"
            class="flex text-sm items-center gap-3 px-4 py-2 rounded-lg hover:bg-primary hover:text-white text-gray-700 transition-all duration-200"
            :class="{
              'bg-primary text-white font-semibold': $route.path === item.path,
            }"
          >
            <component
              :is="item.icon"
              class="w-5 h-5 text-gray-500"
              v-if="item.icon"
            />
            <span>{{ item.name }}</span>
          </router-link>
        </template>
      </li>
    </ul>
  </nav>
</template>

<script>
import { ref } from "vue";
import DashboardSVG from "@/components/svg/DashboardSVG.vue";
import ReimbursementSVG from "@/components/svg/ReimbursementSVG.vue";
import PaymentSVG from "@/components/svg/PaymentSVG.vue";
import TrackingSVG from "@/components/svg/TrackingSVG.vue";

export default {
  setup() {
    const itemMenu = ref([
      {
        id: 1,
        name: "Dashboard",
        icon: DashboardSVG,
        path: "/admin/dashboard",
      },
      {
        id: 2,
        name: "Reimbursement",
        icon: ReimbursementSVG,
        path: "/admin/reimbursement",
      },
      {
        id: 3,
        name: "Payment Process",
        icon: PaymentSVG,
        path: "/admin/payment",
      },
      {
        id: 4,
        name: "Tracking",
        icon: TrackingSVG,
        path: "/",
      },
    ]);

    return {
      itemMenu,
    };
  },
};
</script>
